const aaa = [

	{
		path: "rukuList",
		component: () => import("@/views/kucun/ruku/list.vue"),
		meta:{title:'入库查询',keepAlive:true},
	},
	{
		path: "rukuAdd",
		component: () => import("@/views/kucun/ruku/add.vue"),
		meta:{title:'入库查询'},
	},
	{
		path: "rukuSee",
		component: () => import("@/views/kucun/ruku/see.vue"),
		meta:{title:'入库查询'},
	},
	
]
export default aaa;